import { useTranslation } from 'react-i18next';
import LanguageMenu from '@/components/common/LanguageMenu';
import { dashboardCopy, getDashboardLanguage } from './language';
import HeaderActions from './HeaderActions';

interface HeaderProps {
  onMenuClick: () => void;
}

export default function Header({ onMenuClick }: HeaderProps) {
  const { i18n } = useTranslation();
  const language = getDashboardLanguage(i18n.resolvedLanguage ?? i18n.language);
  const copy = dashboardCopy[language];

  return (
    <header className="dashboard-header relative z-40 flex h-16 w-full shrink-0 items-center gap-1.5 border-b px-2 sm:gap-3 sm:px-4 md:px-8">
      <button type="button" onClick={onMenuClick} className="flex size-11 shrink-0 cursor-pointer items-center justify-center rounded-lg text-foreground-900 hover:bg-background-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 lg:hidden" aria-label={copy.menu}>
        <i className="ri-menu-line text-xl" aria-hidden="true" />
      </button>

      <div className="dashboard-header-search hidden w-72 items-center gap-2 rounded-lg border px-3 py-2 md:flex">
        <i className="ri-search-line text-sm text-foreground-400" aria-hidden="true" />
        <input type="search" aria-label={copy.search} placeholder={copy.search} className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none" />
      </div>

      <div className="flex-1" />
      <div className="dashboard-header-language shrink-0">
        <LanguageMenu />
      </div>
      <HeaderActions language={language} />
    </header>
  );
}
